export default function Container({
  children,
  className,
  size = "default",
}: {
  children: React.ReactNode;
  className?: string;
  size?: "default" | "large" | "huge";
}) {
  let containerClass;
  switch (size) {
    case "large":
      containerClass = "container-large";
      break;
    case "huge":
      containerClass = "container-huge";
      break;
    default:
      containerClass = "container-default";
  }

  return (
    <div className={`${containerClass} padding-global ${className || ""}`}>
      {children}
    </div>
  );
}
